/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/key-1214374': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.71 6.53l-1.42-1.41 1.42-1.41a1 1 0 10-1.42-1.42L9.75 12.83a5 5 0 101.42 1.42l4.88-4.89 1.41 1.42a1 1 0 00.71.29 1 1 0 00.71-.29 1 1 0 000-1.42L17.46 8l1.42-1.42L20.29 8a1 1 0 00.71.29 1 1 0 00.71-.29 1 1 0 000-1.47zM7 20a3 3 0 113-3 3 3 0 01-3 3z"/>'
  }
})
